import { EIconSize } from 'utils/constants/app/ui';
import {
  EXTERNAL_MARKET_TOOLTIPS,
  Markets_Tooltips
} from 'utils/constants/markets';
import { GlobalIcon } from 'components/GlobalIcon';
import { Tooltip } from 'newcomponents/UI/Tooltip';

type TMarketInfoTooltipProps = {
  marketType: string;
};

export const MarketInfoTooltip = ({ marketType }: TMarketInfoTooltipProps) => {
  return (
    <div className="market-tooltip">
      <Tooltip
        title={
          Markets_Tooltips[marketType] ?? EXTERNAL_MARKET_TOOLTIPS[marketType]
        }
        arrowPointAtCenter={false}
        trigger={['hover', 'click']}
        stopPropogation
      >
        <GlobalIcon
          lib="generic"
          name="info"
          theme="default"
          size={EIconSize._16}
          className="marketList__paperclip-icon"
        />
      </Tooltip>
    </div>
  );
};
